import { render, staticRenderFns } from "./addChildren.vue?vue&type=template&id=4fecbd56&"
import script from "./addChildren.vue?vue&type=script&lang=js&"
export * from "./addChildren.vue?vue&type=script&lang=js&"
import style0 from "./addChildren.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports